import resume from '../assets/pdf/Pruthil-Tejani-Resume.pdf'
import pruthil from '../assets/png/pruthil.jpg'

export const headerData = {
    name: 'Pruthil Tejani',
    title: "Full Stack Developer",
    desciption:"Building scalable web applications with Laravel, Livewire, Node.js, and Tailwind CSS. Available for freelance & contract work.",
    image: pruthil,
    resumePdf: resume
}
